import React from 'react'
import { useStatusCode } from 'contexts/StatusCodeContext'

const Status = ({ code, children }) => {
  const context = useStatusCode()

  if (context) {
    context.status = code
  }

  return <>{children}</>
}

export default Status